import { render, staticRenderFns } from "./AegClaimStakeholders.vue?vue&type=template&id=517f530f"
import script from "./AegClaimStakeholders.vue?vue&type=script&lang=js"
export * from "./AegClaimStakeholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports